import { render } from "./SettingsOverlay.vue?vue&type=template&id=3e60a61b&scoped=true&lang=pug"
import script from "./SettingsOverlay.vue?vue&type=script&lang=js"
export * from "./SettingsOverlay.vue?vue&type=script&lang=js"

import "./SettingsOverlay.vue?vue&type=style&index=0&id=3e60a61b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e60a61b"]])

export default __exports__